// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../set/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var set = convertToFP(fn, 2);
export default set;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/set/index.js
// module id = 967
// module chunks = 0